////////////////////////////////////////////////////////////
//                                                        //
//  Program: ListingGeneralArrivalInstruction.jsx         //
//  Application: Listing General Arrival Instruction      //
//  Option: Listing-level arrival instructions for all    //
//          lock types (no Loqron amenity gate required)  //
//  Developer: Orion Haus Dev                             //
//                                                        //
////////////////////////////////////////////////////////////

import React, { Component } from "react";
import SimpleReactValidator from "simple-react-validator";
import Alerts from "../common/Alerts";
import editIcon from "./../../assets/images/edit-pen-icon.svg";
import FileUploadService from "../../services/FileUploadService";
import HTMLEllipsis from "react-lines-ellipsis/lib/html";
import renderHTML from "react-render-html";
import NoData from "../common/NoData";
import JoditEditor from "jodit-react";
import { Jodit } from "jodit";
import ListingService from "../../services/ListingService";

export class ListingGeneralArrivalInstruction extends Component {
  constructor(props) {
    super(props);

    this.validator = new SimpleReactValidator({ autoForceUpdate: this });

    this.state = {
      viewMode: 0,
      open: global.showOpen,
      eventKey: "",
      showSpinner: false,
      loading: false,
      showAlertModal: false,
      alertModalType: "",
      alertModalTitle: "",
      alertModalMessage: "",
      input: {},
      errors: {},
      toggleSwitchDark2: true,
      status_id: true,
      listing_slug: this.props.listing_slug,
      property_slug: this.props.property_slug,
      isSubmit: false,
      pathname: window.location.pathname,
      arrival_instruction: "",
      descShowRules: 0,
    };

    this._alertTimer = null;
    this.fullTextRules = this.fullTextRules.bind(this);
    this.setContent = this.setContent.bind(this);
    this.editorConfig = {
      extraButtons: ["uploadImage", "uploadImageVideo"],
    };
  }

  async componentDidMount() {
    this.setState({ confirm_back: 0 });
    this.uploadImageButton();
    this.uploadVideoButton();
    this.fetchListingData();
  }

  componentWillUnmount() {
    if (this._alertTimer) {
      clearTimeout(this._alertTimer);
    }
  }

  async fetchListingData() {
    if (this.props.listing_slug !== undefined) {
      var resData = {};
      let res = await ListingService.getListing(this.props.listing_slug);
      if (global.successStatus.includes(res.status)) {
        resData.arrival_instruction = res.data.arrival_instruction
          ? res.data.arrival_instruction
          : "";
      }
      this.setState(resData);
    }
  }

  setContent(value) {
    this.setState({ arrival_instruction: value });
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    this.validator.hideMessages();
  }

  changeView = () => {
    this.setState(
      (prevState) => ({
        viewMode: prevState.viewMode === 1 ? 0 : 1,
        confirm_back: 0,
      }),
      () => {
        if (this.state.viewMode === 0) this.fetchListingData();
        this.validator.hideMessages();
      }
    );
  };

  uploadImageButton = () => {
    Jodit.defaultOptions.controls.uploadImage = {
      name: "Upload image",
      exec: async (editor) => {
        await this.imageUpload(editor);
      },
    };
  };

  imageUpload = (editor) => {
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();

    input.onchange = async function () {
      const imageFile = input.files[0];
      if (!imageFile) return;
      if (!imageFile.name.match(/\.(jpg|jpeg|png)$/)) return;

      let fileData = new FormData();
      fileData.append("file", imageFile, imageFile.name);
      fileData.append("fileName", imageFile.name);
      fileData.append("folderName", "jodit");
      const response = await FileUploadService.uploadFromEditor(fileData);
      if (global.successStatus.includes(response.status)) {
        this.insertImage(editor, response.data.filePath);
      }
    }.bind(this);
  };

  insertImage = (editor, url) => {
    const image = editor.selection.j.createInside.element("img");
    image.setAttribute("src", url);
    editor.selection.insertNode(image);
  };

  uploadVideoButton = () => {
    Jodit.defaultOptions.controls.uploadImageVideo = {
      name: "Upload video",
      exec: async (editor) => {
        await this.videoUpload(editor);
      },
    };
  };

  videoUpload = (editor) => {
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "video/*");
    input.click();

    input.onchange = async function () {
      const videoFile = input.files[0];
      if (!videoFile) return;

      let fileData = new FormData();
      fileData.append("file", videoFile, videoFile.name);
      fileData.append("fileName", videoFile.name);
      fileData.append("folderName", "jodit");
      const response = await FileUploadService.uploadFromEditor(fileData);
      if (global.successStatus.includes(response.status)) {
        const video = editor.selection.j.createInside.element("video");
        video.setAttribute("src", response.data.filePath);
        video.setAttribute("controls", "controls");
        editor.selection.insertNode(video);
      }
    }.bind(this);
  };

  fullTextRules() {
    this.setState((prevState) => ({
      descShowRules: prevState.descShowRules === 0 ? 1 : 0,
    }));
  }

  saveOrUpdateDescription = async (e) => {
    e.preventDefault();
    if (this.validator.allValid()) {
      this.setState({ showSpinner: true, isSubmit: true });

      let inputData = {
        tab: "general-arrival-instructions",
        arrival_instruction: this.state.arrival_instruction,
      };

      if (this.state.listing_slug !== undefined) {
        let res = await ListingService.updateGeneralArrivalInstruction(
          this.state.listing_slug,
          inputData
        );
        if (global.successStatus.includes(res.status)) {
          this.setState({
            showAlertModal: true,
            alertModalType: "success",
            alertModalTitle: "Success",
            alertModalMessage: res.message ? res.message : "Success",
          });
          this.fetchListingData();
          this.setState({ viewMode: 0 });
        } else {
          if (res.data.result && res.data.result.errorDetail !== null) {
            let errors = {};
            res.data.result.errorDetail.forEach((item) => {
              errors[item.errorField] = item.errorMessage[0];
            });
            this.setState({ errors: errors });
          }
        }
      }
      this.setState({ showSpinner: false, isSubmit: false });
      this._alertTimer = setTimeout(
        () => this.setState({ showAlertModal: false }),
        global.alert_close_time
      );
    } else {
      this.validator.showMessages();
      const input = document.getElementsByClassName("text-danger");
      if (input.length > 0) {
        input[0].scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "start",
        });
      }
    }
  };

  render() {
    return (
      <>
        <div className="dashboardRightcard dashbaord-pageHeadertitle- background-none pt-0 pd-l-30 pd-r-30 swipersectionBtns">
          <div className="d-flex flex-wrap justify-content-end bothBtn align-items-center swiperBtns">
            {this.state.viewMode === 0 &&
            global.userPermissions.checkPermission("single-unit-update") ? (
              <>
                <button
                  className="btn-success-outline-small ml-3 mr-3"
                  onClick={this.changeView}
                >
                  <img src={editIcon} alt="" />
                  Edit
                </button>
              </>
            ) : (
              <>
                <div className="d-flex">
                  <button
                    type="button"
                    className="btn-success-outline-small ml-3"
                    onClick={() => {
                      if (this.state.confirm_back === 1) {
                        if (
                          window.confirm("Do you want to exit without saving?")
                        ) {
                          this.changeView();
                        } else {
                          return false;
                        }
                      } else {
                        this.changeView();
                      }
                    }}
                  >
                    Cancel
                  </button>

                  {global.userPermissions.checkPermission(
                    "single-unit-update"
                  ) ? (
                    <button
                      className="btn-success  mr-3"
                      onClick={this.saveOrUpdateDescription}
                    >
                      {this.state.isSubmit ? global.loader : "Save"}
                    </button>
                  ) : (
                    ""
                  )}
                </div>
              </>
            )}
          </div>
          <div className="col-md-12 pd-lg-l-30 pd-lg-r-30 pd-xs-l-15 pd-xs-r-0  mg-t-15">
            <Alerts
              show={this.state.showAlertModal}
              type={this.state.alertModalType}
              title={this.state.alertModalTitle}
              message={this.state.alertModalMessage}
            />
          </div>

          {this.state.viewMode === 0 ? (
            <div className="row m-0 listing_fee_price">
              <div className="col-lg-12 pd-l-30 pd-r-30 pd-xs-l-15 pd-lg-l-30 pd-xs-r-0 pd-lg-r-30">
                <h3 className="mg-l-0 background-head">Arrival Instructions</h3>
              </div>
              <div className="row col-md-12 mg-lg-t-0 mg-xs-t-10 mg-md-t-0 pd-l-30 pd-r-30 pd-xs-l-15 pd-lg-l-30 pd-xs-r-0 pd-lg-r-30 border-bottom-0">
                {this.state.arrival_instruction ? (
                  <>
                    <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 pd-l-30 pd-r-30 pl-0 listing_detail">
                      <div className="para">
                        {this.state.arrival_instruction.length >
                        global.showMoreLength ? (
                          this.state.descShowRules === 0 ? (
                            <>
                              <HTMLEllipsis
                                unsafeHTML={this.state.arrival_instruction}
                                maxLine="6"
                                ellipsis=""
                                trimright="true"
                                basedOn="letters"
                              />
                              <p
                                className="hand-cursor showmore"
                                onClick={this.fullTextRules}
                              >
                                Show More
                              </p>
                            </>
                          ) : (
                            <>
                              {renderHTML("" + this.state.arrival_instruction)}
                              <p
                                className="hand-cursor showmore"
                                onClick={this.fullTextRules}
                              >
                                Show Less
                              </p>
                            </>
                          )
                        ) : (
                          renderHTML("" + this.state.arrival_instruction)
                        )}
                      </div>
                    </div>
                  </>
                ) : (
                  <NoData msg="Arrival Instructions" action=" Edit " />
                )}
              </div>
            </div>
          ) : (
            ""
          )}

          {this.state.viewMode === 1 ? (
            <div className="m-0 listing_fee_price">
              <div className="col-lg-12 pd-l-30 pd-r-30 pd-xs-l-15 pd-lg-l-30 pd-xs-r-0 pd-lg-r-30">
                <h3 className="mg-l-0 background-head">Arrival Instructions</h3>
              </div>
              <div className="row align-items-center pd-lg-b-15 pd-xs-b-0 border-bottom-0 pd-lg-r-15">
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mg-t-5 mg-md-t-0 mg-b-15 pd-xs-l-0 pd-lg-l-30 pd-xs-r-0 pd-lg-r-30">
                  <label className="form-label text-left pd-b-5">
                    Available merge fields: [Parking-Spot] [Key-Cafe-Code]
                    [Latch-Door-Code] [Latch-Laundry-Code] [Wifi-Name]
                    [Wifi-Password] [Unit-Number] [Address]
                  </label>
                  <JoditEditor
                    config={this.editorConfig}
                    ref={null}
                    name="arrival_instruction"
                    id="arrival_instruction"
                    value={this.state.arrival_instruction}
                    onBlur={(newContent) => this.setContent(newContent)}
                  />
                  {this.state.errors.arrival_instruction ? (
                    <div className="text-danger">
                      {this.state.errors.arrival_instruction}
                    </div>
                  ) : (
                    this.validator.message(
                      "arrival instructions",
                      this.state.arrival_instruction,
                      "max:100000",
                      { className: "text-danger" }
                    )
                  )}
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </>
    );
  }
}

export default ListingGeneralArrivalInstruction;
